import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Button } from '@/components/ui/button';
import { PwaUpdateDialogProps } from './types';
import { RefreshCw } from 'lucide-react';

const PwaUpdateDialog = (props: PwaUpdateDialogProps) => {
  const {
    error,
    isOpen,
    isUpdating,
    onUpdate
  } = props;

  const onEscapeKeyDown = (event: Event): void => {
    event.preventDefault();
  };

  const onInteractOutside = (event: Event): void => {
    event.preventDefault();
  };

  const actionLabel = isUpdating ? 'Обновляем...' : 'Обновить';
  const description = isUpdating
    ? 'Не закрывайте приложение — сейчас загрузится новая версия.'
    : 'Чтобы продолжить работу, обновите приложение до актуальной версии.';
  const title = isUpdating ? 'Обновляем приложение...' : 'Доступна новая версия';

  return (
    <DialogPrimitive.Root
      modal
      open={isOpen}
    >
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[100] bg-black/80" />
        <DialogPrimitive.Content
          className="fixed left-1/2 top-1/2 z-[101] grid w-[calc(100vw-32px)] max-w-[390px] -translate-x-1/2 -translate-y-1/2 gap-6 px-4 pb-6 pt-4 font-sans text-foreground rounded-2xl border border-border-strong bg-surface shadow-none outline-none"
          onEscapeKeyDown={onEscapeKeyDown}
          onInteractOutside={onInteractOutside}
          onPointerDownOutside={onInteractOutside}
        >
          <div className="flex flex-col gap-2">
            <DialogPrimitive.Title className="flex items-center gap-2 font-sans text-[18px] font-semibold leading-6 text-foreground">
              <RefreshCw
                aria-hidden
                className="size-5 shrink-0"
              />
              {title}
            </DialogPrimitive.Title>
            <DialogPrimitive.Description className="text-sm leading-5 text-muted-foreground">
              {description}
            </DialogPrimitive.Description>
            {error ? (
              <p className="text-xs leading-4 text-destructive">
                Не удалось обновить приложение. Попробуйте еще раз.
              </p>
            ) : null}
          </div>
          <Button
            className="w-full"
            loading={isUpdating}
            onClick={onUpdate}
            type="button"
          >
            {actionLabel}
          </Button>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export default PwaUpdateDialog;